import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard } from 'lucide-react';
import { useAuth } from "./AuthContext";

const AuthNavButton = ({ isMobile = false }) => {
    const { isAuthenticated, user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    if (isAuthenticated) {
        return (
            <div className="flex items-center gap-4">
                <Link
                    to="/painel"
                    className={`flex items-center gap-2 font-medium transition-colors ${isMobile
                            ? 'bg-[#A56096] text-white px-4 py-2 rounded-full text-sm'
                            : 'text-[#3A5859] hover:text-[#A56096]'
                        }`}
                >
                    <LayoutDashboard className="h-4 w-4" />
                    {`Painel`}
                </Link>

                <button
                    onClick={handleLogout}
                    title="Sair"
                    className={`flex items-center justify-center p-2 rounded-full transition-colors ${isMobile
                            ? 'bg-red-500 text-white hover:bg-red-600'
                            : 'bg-red-100 text-red-600 hover:bg-red-200'
                        }`}
                >
                    <LogOut className="h-5 w-5" />
                </button>
            </div>
        );
    }

    return (
        <Link
            to="/login"
            className={`bg-[#A56096] text-white rounded-full hover:bg-[#945586] transition-colors font-medium ${isMobile ? 'px-4 py-2 text-sm' : 'px-6 py-2'
                }`}
        >
            Entrar
        </Link>
    );
};

export default AuthNavButton;